(function ($, window, document) {
	const $win = $(window);
	const $doc = $(document);
	const $header = $('.c-header');
	const $headerMenu = $('#c-header__menu');
	const html = document.querySelector('html');

	$('.open-popup-link').magnificPopup({
		type: 'inline'
	});

	$('.js-list-item').on('click', function () {
		$(this).toggleClass('active');
		$(this).find('.section--tenants-list-item--content').slideToggle();
	})

	$('.section-column--images').on('init', function (event, slick, currentSlide, nextSlide) {
		$win.trigger('resize');
	}).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		nextArrow: '<button type="button" class="slick-next" aria-label="Next"><img src="/wp-content/themes/merrifield-business-park/assets/dist/images/page-banner-scroller.svg"></button>',
		prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><img src="/wp-content/themes/merrifield-business-park/assets/dist/images/page-banner-scroller.svg"></button>',
	});

	$win.scroll(function () {
		if ($(this).scrollTop() < 50) {
			$('.c-header').addClass('is-at-top');
		} else {
			$('.c-header').removeClass('is-at-top');
		}
	});

	// Toggle the active class when the filter is clicked
	$('.js-filter-accordion').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		let $this = $(this);
		$this.toggleClass("active");
	});

	function updateNewsPagination() {
		let $filterSettings = $('.section-news-filters');
		let currentPage = parseInt($filterSettings.data('page'));
		let perPage = $filterSettings.data('per-page');

		// Calculate total pages;
		let $totalElements = $('[data-is-selected="1"]:not([data-is-featured="1"])');
		let totalPages = Math.ceil($totalElements.length / perPage);
		$filterSettings.attr('data-total-pages', totalPages);

		// Hide all elements initially
		$totalElements.hide();

		// Show only the elements that belong to the current page
		let startIdx = (currentPage - 1) * perPage;
		let endIdx = startIdx + perPage;
		$totalElements.slice(startIdx, endIdx).show();

		// Update pagination UI
		let $paginationList = $('.c-pagination');

		if (totalPages > 1) {
			$paginationList.show();
			$paginationList.empty();
			$paginationList.append('<li class="o-list-inline__item c-blog-links__link"><a href="#" class="page-numbers">&lt;</a></li>');

			for (let i = 1; i <= totalPages; i++) {
				let activeClass = i === currentPage ? ' current' : '';
				$paginationList.append('<li class="o-list-inline__item c-blog-links__link"><a class="page-numbers' + activeClass + '" href="#" data-page="' + i + '">' + i + '</a></li>');
			}

			$paginationList.append('<li class="o-list-inline__item c-blog-links__link"><a href="#" class="page-numbers">&gt;</a></li>');
		} else {
			$paginationList.hide();
		}
	}

	// Handle pagination clicks
	$('.c-pagination').on('click', 'a.page-numbers', function (e) {
		e.preventDefault();

		let $this = $(this);
		let $filterSettings = $('.section-news-filters');
		let currentPage = parseInt($filterSettings.data('page'));
		let totalPages = parseInt($filterSettings.attr('data-total-pages'));
		let $currentSelectedFilter = $('.category-filter li[aria-selected="true"]');

		if ($this.text() === '<') {
			// Previous page
			currentPage = Math.max(1, currentPage - 1);
		} else if ($this.text() === '>') {
			// Next page
			currentPage = Math.min(totalPages, currentPage + 1);
		} else {
			// Specific page
			currentPage = parseInt($this.text());
		}

		$filterSettings.data('page', currentPage);

		if ($currentSelectedFilter.attr('data-filter') == "all") {
			if (currentPage != 1) {
				$('.section-featured-posts').hide();
			} else {
				$('.section-featured-posts').show();
			}
		}

		$('html, body').animate({
			scrollTop: $(".c-page-content").offset().top - 75
		}, 1000);

		updateNewsPagination();
	});

	function initImageZoom() {
		const $img = $('.mfp-img');
		const $container = $('.mfp-content');

		$img.on('dragstart', function (event) {
			event.preventDefault();
		});

		let isDragging = false;
		let startX, startY, initialOffsetX = 0, initialOffsetY = 0;
		let zoomLevel = 1;
		let offsetX = 0, offsetY = 0;

		// Touch variables
		let initialDistance;
		let initialZoomLevel;

		$img.on('mousedown', function (event) {
			isDragging = true;
			startX = event.clientX;
			startY = event.clientY;
			initialOffsetX = offsetX;
			initialOffsetY = offsetY;
		});

		$img.on('mousemove', function (event) {
			if (!isDragging) return;

			offsetX = initialOffsetX + (event.clientX - startX);
			offsetY = initialOffsetY + (event.clientY - startY);

			$img.css('transform', `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`);
		});

		$img.on('mouseup', function () {
			isDragging = false;
		});

		// Touch drag and zoom
		$img.on('touchstart', function (event) {
			if (event.originalEvent.touches.length === 2) {
				// Two fingers detected, initiate pinch zoom parameters
				initialDistance = Math.hypot(
					event.originalEvent.touches[0].pageX - event.originalEvent.touches[1].pageX,
					event.originalEvent.touches[0].pageY - event.originalEvent.touches[1].pageY
				);
				initialZoomLevel = zoomLevel;
			} else {
				// Single finger, initiate drag parameters
				isDragging = true;
				startX = event.originalEvent.touches[0].clientX;
				startY = event.originalEvent.touches[0].clientY;
				initialOffsetX = offsetX;
				initialOffsetY = offsetY;
			}
		});

		$img.on('touchmove', function (event) {
			if (event.originalEvent.touches.length === 2) {
				// Handle pinch zoom
				const distance = Math.hypot(
					event.originalEvent.touches[0].pageX - event.originalEvent.touches[1].pageX,
					event.originalEvent.touches[0].pageY - event.originalEvent.touches[1].pageY
				);
				zoomLevel = initialZoomLevel * (distance / initialDistance);
				zoomLevel = Math.min(Math.max(0.5, zoomLevel), 3);
			} else {
				// Handle drag
				offsetX = initialOffsetX + (event.originalEvent.touches[0].clientX - startX);
				offsetY = initialOffsetY + (event.originalEvent.touches[0].clientY - startY);
			}

			$img.css('transform', `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`);
		});

		$img.on('touchend', function () {
			isDragging = false;
		});

		$container.on('wheel', function (event) {
			zoomLevel += event.originalEvent.deltaY * -0.001;

			zoomLevel = Math.min(Math.max(0.5, zoomLevel), 3);

			$img.css('transform', `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`);
		});

		// Reset position on right-click
		$('.mfp-img').on('contextmenu', function (event) {
			event.preventDefault();
			// Assuming you're using transform for panning and zooming
			$(this).css({
				'transform': 'none'
			});
		});
	}

	function setTenantHeadingHeight() {
		const $tenantSections = $('.section--tenants');

		if (!$tenantSections.length) {
			return;
		}

		$tenantSections.each(function () {
			const $section = $(this);
			const $tenantGrid = $section.find('.tenants');
			const $headingContainers = $section.find('.tenant__heading-container');

			if (!$tenantGrid.length || !$headingContainers.length) {
				return;
			}

			const gridComputedStyle = window.getComputedStyle($tenantGrid[0]);
			const gridColumnCount = gridComputedStyle.getPropertyValue("grid-template-columns").split(" ").length;
			const gridRowCount = gridComputedStyle.getPropertyValue("grid-template-rows").split(" ").length;

			for (let i = 0; i < gridRowCount; i++) {
				let maxHeightHeading = 0;
				const rowStartIndex = i * gridColumnCount;
				const rowEndIndex = rowStartIndex + gridColumnCount;
				const $rowHeadingContainers = $headingContainers.slice(rowStartIndex, rowEndIndex);

				$rowHeadingContainers.each(function () {
					const $headingContainer = $(this);
					const $heading = $headingContainer.find('.tenant__heading');
					if ($heading.height() > maxHeightHeading) {
						maxHeightHeading = $heading.height();
					}
				});

				$rowHeadingContainers.css('height', maxHeightHeading);
			}
		});
	}

	function matchHeight() {
		// Initialize variables
		let maxHeightHeading = 0;
		let maxHeightParagraph = 0;

		// Reset height to auto for recalculation
		$('.section-column--heading, .section-column--main > p').css('height', 'auto');

		// Loop to find the tallest heading
		$('.section-column--heading').each(function () {
			if ($(this).height() > maxHeightHeading) {
				maxHeightHeading = $(this).height();
			}
		});

		// Loop to find the tallest paragraph
		$('.section-column--main > p').each(function () {
			if ($(this).height() > maxHeightParagraph) {
				maxHeightParagraph = $(this).height();
			}
		});

		// Set all elements to the tallest height
		$('.section-column--heading').height(maxHeightHeading);
		$('.section-column--main > p').height(maxHeightParagraph);
	}

	function initNews() {
		$('.category-filter li[data-filter]').on('click', function (e) {
			e.preventDefault();
			let $this = $(this);

			if ($this && $this.length) {
				let $selectedItem = $this.eq(0);
				$('.category-filter li[data-filter]').attr("aria-selected", "false");
				$selectedItem.attr("aria-selected", "true");
				let selectedItemFilter = $selectedItem.data('filter');
				let selectItemTitle = $selectedItem.find('a').html();

				console.log(selectedItemFilter, selectItemTitle);
				if (selectedItemFilter != 'all') {
					$('.filter-head').html(selectItemTitle);
					$('[data-category]')
						.hide()
						.attr('data-is-selected', '0');
					$('[data-category="' + selectedItemFilter + '"]')
						.show()
						.attr('data-is-selected', '1');
					$('.section-featured-posts')
						.hide();
				} else {
					$('.filter-head').html("Filter Categories");
					$('[data-category][data-is-featured="0"]')
						.show()
						.attr('data-is-selected', '1');

					$('[data-is-featured="1"]')
						.hide()
						.attr('data-is-selected', '0');

					$('.section-featured-posts').show();
				}
			}


			let $filterSettings = $('.section-news-filters');
			$filterSettings.data('page', 1);

			$('html, body').animate({
				scrollTop: $(".c-page-content").offset().top - 75
			}, 1000);

			updateNewsPagination();
		})

		// Remove the active class when clicking outside
		$doc.on('click', function (e) {
			$('.js-filter-accordion.active').removeClass("active");
		});

		updateNewsPagination();
	}

	function preventDefaultZoom(event) {
		if (event.touches.length > 1) {
			event.preventDefault();
		}
	}

	$('.image-popup').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		fixedContentPos: true,
		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // don't foget to change the duration also in CSS
		},
		callbacks: {
			open: function () {
				// Disable default browser zoom
				document.addEventListener('touchmove', preventDefaultZoom, { passive: false });
				// Initialize your image zoom function
				initImageZoom();
			},
			close: function () {
				// Re-enable default browser zoom
				document.removeEventListener('touchmove', preventDefaultZoom, { passive: false });
			}
		}
	});

	function initTenantAccordions() {
		const $tenants = $('.tenant');

		if (!$tenants.length) {
			return;
		}

		$tenants.each(function () {
			const tenant = this;
			const tenantDetails = tenant.querySelector('.tenant__details');
			const tenantBtn = tenant.querySelector('.js-button-tenant');
			const tenantDesc = tenant.querySelector('.tenant__description');

			if (!tenantDetails || !tenantBtn) {
				return;
			}

			tenantBtn.addEventListener('click', function () {
				let startHeight = `${tenantDetails.clientHeight}px`;
				let endHeight = 0;

				tenant.classList.remove('is-closed');

				if (tenant.classList.contains('is-open')) {
					tenant.classList.remove('is-open');
					if (tenantDesc) {
						const descHeight = tenantDesc.clientHeight;
						endHeight = `min(${descHeight}px, 3lh)`;
					} else {
						endHeight = `3lh`;
					}
					tenantBtn.textContent = 'More information';
				} else {
					tenant.classList.add('is-open');
					endHeight = `${tenantDetails.scrollHeight}px`;
					tenantBtn.textContent = 'Less information';
				}

				tenantDetails.animate([
					{ maxHeight: startHeight, easing: "ease" },
					{ maxHeight: endHeight, easing: "ease" },
				], {
					duration: 300,
					iterations: 1,
				}).finished.then(() => {
					if (!tenant.classList.contains('is-open')) {
						tenant.classList.add('is-closed');
					}
				});
			});
		});
	}

	function initStatisticTilesSlider() {
		const $sliders = $('.js-slider-statistic-tiles');

		if (!$sliders.length) {
			return;
		}

		$sliders.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 1500,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 450,
					settings: {
						slidesToShow: 1,
						variableWidth: true,
					}
				}
			]
		});
	}

	function scrollToElementFromHash(hash) {
		if (hash.substring(0, 1) !== '#') {
			return false;
		}

		const elementId = hash.substring(1);
		const element = document.getElementById(elementId);

		if (element) {
			element.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
			return true;
		}
		return false;
	}

	$('a[href^="#"]').on('click', function (e) {
		const href = this.getAttribute("href");
		const currentUrl = new URL(window.location.href);
		const currentUrlString = currentUrl.origin + currentUrl.pathname;
		const linkUrl = new URL(href, currentUrlString);

		if (linkUrl.origin + linkUrl.pathname !== currentUrlString) {
			return;
		}

		if (scrollToElementFromHash(linkUrl.hash)) {
			e.preventDefault();
			if($header.hasClass("has-menu-open")) {
				$header.removeClass("has-menu-open");
				$headerMenu.slideUp();
			}
		}
	});

	function updateCssVariables() {
		const headerHeight = $header.outerHeight();

		html.style.setProperty('--header-height', `${headerHeight}px`);
	}

	initTenantAccordions();
	initStatisticTilesSlider();
	matchHeight();
	setTenantHeadingHeight();
	updateCssVariables();
	scrollToElementFromHash(window.location.hash);

	$win.on("load", function () {
		initNews();
	}).on("resize", function () {
		matchHeight();
		setTenantHeadingHeight();
		updateCssVariables();
	});
})(jQuery, window, document);